enum Constants {
  DEFAULT_ORG_KEY = 'country:de',
  DEFAULT_TREE_TYPE = 'hermes_org',
}

export default Constants;
